<script setup lang="ts">
import type { Attr } from "~/types";
import { categoryOrder, getCategory } from "~/utils/sekou/category";

const attr_num = useRoute().params.attr_num as string;
const attrs = inject<Attr[]>("attrs", []);
const cate = getCategory();

// 現在開いているカテゴリを含むか
function includeLink(category: number) {
  // 絞り込んでいない場合探す必要がない
  if (!attr_num || !attrs.length) return false;

  // カテゴリでフィルタした中からattr_numが現在絞り込み中の条件にマッチするリンクがあるか
  const filtered = attrs.filter((a) => a.category == category);
  return filtered.some((e) => e.attr_num == parseInt(attr_num));
}
</script>

<template>
  <div class="flex flex-wrap flex-col">
    <MenuAccordion
      v-for="category in categoryOrder"
      :title="cate[category]"
      :open="includeLink(category)"
    >
      <ul>
        <li
          class="p-2"
          v-for="a in attrs?.filter((a) => a.category == category)"
          :key="a.attr_num"
        >
          <SekouAttrLink :attr="a" :disable-tag="true" />
        </li>
      </ul>
    </MenuAccordion>
  </div>
</template>
